import { Box } from '@mui/material';

import type { useCardResize } from '../cards/hooks/useCardResize';
import type { CardResizeHandle } from '../cards/utils/cardResizeGeometry';

interface ClusterResizeHandlesProps {
  getHandleProps: ReturnType<typeof useCardResize>['getHandleProps'];
}

export function ClusterResizeHandles({ getHandleProps }: ClusterResizeHandlesProps) {
  return (
    <>
      <ClusterResizeHandle direction="e" getHandleProps={getHandleProps} />
      <ClusterResizeHandle direction="s" getHandleProps={getHandleProps} />
    </>
  );
}

function ClusterResizeHandle({
  direction,
  getHandleProps,
}: {
  direction: CardResizeHandle;
  getHandleProps: ReturnType<typeof useCardResize>['getHandleProps'];
}) {
  return (
    <Box
      component="span"
      data-resize-handle={direction}
      {...getHandleProps(direction)}
      sx={{
        bgcolor: 'transparent',
        display: 'block',
        position: 'absolute',
        touchAction: 'none',
        zIndex: 4,
        ...(direction === 'e'
          ? { bottom: 8, cursor: 'ew-resize', right: -5, top: 8, width: 10 }
          : { bottom: -5, cursor: 'ns-resize', height: 10, left: 8, right: 8 }),
      }}
    />
  );
}
